var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDC64"
    },
    d: "M332.96,204.693H179.04l14.721-88.323c1.375-8.247,8.509-14.291,16.869-14.291h90.74 c8.36,0,15.495,6.045,16.869,14.291L332.96,204.693z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC850"
    },
    d: "M270.489,102.079h-59.858c-8.361,0-15.496,6.044-16.87,14.291l-14.721,88.323h59.858l14.72-88.323 C254.993,108.123,262.127,102.079,270.489,102.079z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFF082"
    },
    cx: 281.653,
    cy: 144.835,
    r: 17.102
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDC64"
    },
    d: "M332.96,409.921H179.04l14.721-88.323c1.375-8.247,8.509-14.291,16.869-14.291h90.74 c8.36,0,15.495,6.045,16.869,14.291L332.96,409.921z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC850"
    },
    d: "M270.489,307.307h-59.858c-8.361,0-15.496,6.044-16.87,14.291l-14.721,88.323h59.858l14.72-88.323 C254.993,313.35,262.127,307.307,270.489,307.307z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFF082"
    },
    cx: 281.653,
    cy: 350.063,
    r: 17.102
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDC64"
    },
    d: "M161.937,409.921H8.017l14.721-88.323c1.375-8.247,8.509-14.291,16.869-14.291h90.741 c8.36,0,15.495,6.045,16.869,14.291L161.937,409.921z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC850"
    },
    d: "M99.466,307.307H39.608c-8.361,0-15.496,6.044-16.87,14.291L8.017,409.921h59.858l14.72-88.323 C83.97,313.35,91.104,307.307,99.466,307.307z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFF082"
    },
    cx: 110.63,
    cy: 350.063,
    r: 17.102
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDC64"
    },
    d: "M503.983,409.921H350.063l14.721-88.323c1.375-8.247,8.509-14.291,16.869-14.291h90.741 c8.36,0,15.495,6.045,16.869,14.291L503.983,409.921z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC850"
    },
    d: "M441.512,307.307h-59.858c-8.361,0-15.496,6.044-16.87,14.291l-14.721,88.323h59.858l14.72-88.323 C426.016,313.35,433.15,307.307,441.512,307.307z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFF082"
    },
    cx: 452.676,
    cy: 350.063,
    r: 17.102
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDC64"
    },
    d: "M247.449,307.307H93.528l14.721-88.323c1.375-8.247,8.509-14.291,16.869-14.291h90.741 c8.36,0,15.495,6.045,16.869,14.291L247.449,307.307z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC850"
    },
    d: "M184.977,204.693h-59.858c-8.361,0-15.496,6.044-16.87,14.291l-14.721,88.323h59.858l14.72-88.323 C169.482,210.737,176.615,204.693,184.977,204.693z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFF082"
    },
    cx: 196.142,
    cy: 247.449,
    r: 17.102
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDC64"
    },
    d: "M418.472,307.307H264.551l14.721-88.323c1.375-8.247,8.509-14.291,16.869-14.291h90.741 c8.36,0,15.495,6.045,16.869,14.291L418.472,307.307z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC850"
    },
    d: "M356,204.693h-59.858c-8.361,0-15.496,6.044-16.87,14.291l-14.721,88.323h59.858l14.72-88.323 C340.505,210.737,347.638,204.693,356,204.693z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFF082"
    },
    cx: 367.165,
    cy: 247.449,
    r: 17.102
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M511.891,408.603L497.17,320.28c-2.027-12.162-12.447-20.99-24.777-20.99h-47.13l-13.604-81.624 c-2.028-12.162-12.448-20.99-24.778-20.99h-47.13l-13.604-81.624c-2.028-12.162-12.448-20.99-24.778-20.99H210.63 c-12.331,0-22.75,8.828-24.777,20.99l-13.604,81.624h-47.13c-12.331,0-22.75,8.828-24.777,20.99L86.737,299.29H39.607 c-12.331,0-22.75,8.828-24.777,20.99L0.109,408.603c-0.387,2.324,0.267,4.701,1.79,6.5c1.523,1.798,3.76,2.835,6.117,2.835h153.921 c2.357,0,4.594-1.037,6.117-2.835c1.523-1.798,2.178-4.175,1.79-6.5l-14.721-88.323c-0.288-1.727-0.762-3.379-1.37-4.956h33.47 c-0.608,1.578-1.083,3.229-1.37,4.956l-14.721,88.323c-0.387,2.324,0.267,4.701,1.79,6.5c1.523,1.799,3.76,2.835,6.117,2.835 h153.921c2.357,0,4.594-1.037,6.117-2.835s2.178-4.175,1.79-6.5l-14.721-88.323c-0.288-1.727-0.762-3.379-1.37-4.956h33.47 c-0.608,1.578-1.083,3.229-1.37,4.956l-14.721,88.323c-0.387,2.324,0.267,4.701,1.79,6.5s3.76,2.835,6.117,2.835h153.921 c2.357,0,4.594-1.037,6.117-2.835C511.623,413.304,512.278,410.926,511.891,408.603z M395.843,220.302l13.165,78.988H274.014 l13.164-78.988c0.733-4.398,4.502-7.592,8.962-7.592h90.741C391.341,212.71,395.11,215.903,395.843,220.302z M254.24,299.29 l-13.604-81.624c-0.288-1.727-0.762-3.379-1.37-4.956h33.47c-0.608,1.578-1.083,3.229-1.37,4.956L257.76,299.29H254.24z  M201.668,117.688c0.733-4.398,4.502-7.592,8.962-7.592h90.74c4.459,0,8.228,3.193,8.962,7.592l13.164,78.988H188.504 L201.668,117.688z M116.157,220.302c0.733-4.398,4.502-7.592,8.962-7.592h90.741c4.459,0,8.228,3.193,8.962,7.592l13.164,78.988 H102.992L116.157,220.302z M139.309,322.916l13.164,78.988H17.48l13.164-78.988c0.733-4.398,4.502-7.592,8.962-7.592h90.741 C134.807,315.324,138.576,318.516,139.309,322.916z M310.332,322.916l13.164,78.988H188.504l13.164-78.988 c0.733-4.398,4.502-7.592,8.962-7.592h90.74C305.83,315.324,309.599,318.516,310.332,322.916z M359.526,401.904l13.164-78.988 c0.733-4.398,4.502-7.592,8.962-7.592h90.741c4.459,0,8.228,3.193,8.962,7.592l13.166,78.988H359.526z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGold);
export default __webpack_public_path__ + "static/media/gold.c2c6cdb0816f1fd135554c130642a987.svg";
export { ForwardRef as ReactComponent };